import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function Breadcrumbs({ breadcrumbs }: Props) {
  return (
    <div className={styles.breadcrumbs}>
      {breadcrumbs.map(({ name, click }, index) =>
        index !== breadcrumbs.length - 1 ? (
          <React.Fragment>
            <p className={styles.breadcrumb} onClick={click}>
              {name}
            </p>
            <p className={styles.separator}>{">"}</p>
          </React.Fragment>
        ) : (
          <p className={styles.breadcrumb} onClick={click}>
            {name}
          </p>
        ),
      )}
    </div>
  );
}

export { Breadcrumbs };
